import { useAxios } from '../utils/axiosConfig';
import { useNotification } from "../contexts/NotificationContext";
import config from '../contexts/ConfigContext';

export interface CommentModel{
    CommentId: number;
    FirstName?: string | null;
    LastName?: string | null;
    UserMentions?: number[];
    TypeId: number;
    CreatedBy?: number | null;
    CommentContent: string;
    AnnotationId?: number | null;
    DocumentId?: number | null;
    LastUpdateDate?: Date | null;
}

export class CommentService{
    axios = useAxios();

    // Define the notification hook
    notification = useNotification();

    async GetComments(typeId: number, Id: number): Promise<CommentModel[]>{
        try {
            const response = await this.axios.get(`${config.API_LABELING_URL}/api/Comments?typeId=${typeId}&Id=${Id}`);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error getting comments: ' + error, 'error');
            console.error('Error getting comments:', error);
            return [];
        }
    }

    async AddComment(comment: CommentModel): Promise<any> {
        try {
            const response = await this.axios.post(config.API_LABELING_URL + "/api/Comments/", comment);
            return response.data;
        }
        catch (error) {
            this.notification.showNotification("Error adding comment: " + error, 'error');
            console.error("Error adding comment: ", error);
            return null;
        }
    }

    async UpdateComment(comment: CommentModel): Promise<any> {
        try {
            const response = await this.axios.put(config.API_LABELING_URL + "/api/Comments/", comment);
            return response.data;
        }
        catch (error) {
            this.notification.showNotification("Error updating comment: " + error, 'error');
            console.error("Error updating comment: ", error);
            return null;
        }
    }

    async DeleteComment(typeId: number, Id: number, commentId: number): Promise<any> {
        try {
            const response = await this.axios.delete(`${config.API_LABELING_URL}/api/Comments?typeId=${typeId}&Id=${Id}&commentId=${commentId}`);
            return response.data;
        }
        catch (error) {
            this.notification.showNotification("Error deleting comment: " + error, 'error');
            console.error("Error deleting comment: ", error);
            return null;
        }
    }
}